import React, { useState } from 'react';
import LinkButton from './LinkButton';
import RemoveConfirmationModal from '../RemoveConfirmation/RemoveConfirmationModal';
import useNotification from '../../Hooks/useNotification.hook';
import { useAppContext } from '../../Services/AppContext';
import { Theme } from '../../Enums/Theme.enum';

interface RemoveButtonProps {
	onClick: () => void;
	title?: string;
	flashMessage?: string;
	confirmationText?: string;
	confirmationTitle?: string;
	showAbort?: boolean;
	customButtons?: React.ReactNode | React.ReactNode[];
	showConfirmation?: boolean;
	firstUpper?: boolean;
	disableFlashMessage?: boolean;
}

export default function RemoveButton(props: RemoveButtonProps) {
	const {
		onClick,
		flashMessage = 'base.deleted',
		title = 'base.shared.delete',
		showAbort,
		confirmationText,
		confirmationTitle,
		customButtons,
		showConfirmation = true,
		firstUpper = false,
		disableFlashMessage = false,
	} = props;
	const [confirmationOpen, setConfirmationOpen] = useState(false);
	const { showNotificationSuccess } = useNotification();
	const { translation } = useAppContext();

	const handlePress = () => {
		setConfirmationOpen(true);
	};

	// @ts-ignore
	const handleConfirm = () => {
		onClick && onClick();
		if (showConfirmation) {
			if (!disableFlashMessage) {
				showNotificationSuccess({
					content: translation[flashMessage],
				});
			}
		}
		setConfirmationOpen(false);
	};

	return (
		<>
			<LinkButton
				onClick={handlePress}
				title={title}
				theme={Theme.RED}
				firstUpper={firstUpper}
			/>
			{confirmationOpen && (
				<RemoveConfirmationModal
					opened
					onClose={() => setConfirmationOpen(false)}
					onConfirm={handleConfirm}
					confirmationText={confirmationText}
					confirmationTitle={confirmationTitle}
					customButtons={customButtons}
					showAbort={showAbort}
				/>
			)}
		</>
	);
}
